import React, { Component } from 'react'
import PropTypes from 'prop-types'
import OnboardingSearchBar from './OnboardingSearchBar'
import OnboardingListItem from './OnboardingListItem'
import NewInvitationForm from './AdminStudentInvitationForm'

/**
 * @class InvitedPersonsWrapper
 * @description Container for displaying, searching, and creating new Invitations (Student or Otherwise)
 */
class InvitedPersonsWrapper extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    data: PropTypes.any.isRequired,
    error: PropTypes.string,
    inviteTitle: PropTypes.string,
    onInvitePerson: PropTypes.func.isRequired,
    onResendInvite: PropTypes.func.isRequired,
    resetError: PropTypes.func,
    title: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      searchFilter: '',
      showInvitePersonForm: false,
    }

    this.onSearch = (searchFilter) => {
      this.setState({searchFilter})
    }

    this.setShowInvitePersonForm = () => {
      if(this.props.error) this.props.resetError()
      this.setState({ showInvitePersonForm: !this.state.showInvitePersonForm })
    }

    this.onInvitePerson = () => {
      this.props.onInvitePerson()
      setTimeout(() => {
        if(!this.props.error) this.setShowInvitePersonForm()
      }, 300)
    }
  }

  /**
   * @method render
   */
  render() {
    const {
      data,
      error,
      inviteTitle,
      onResendInvite,
      title,
    } = this.props
    const { searchFilter, showInvitePersonForm } = this.state

    const filteredData = data.filter(
      invite => invite.inviteeEmail.toLowerCase().indexOf(searchFilter.toLowerCase()) !== -1
    )

    return (
      <div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <h6 style={{display: 'inline-block', marginBottom: 0}}>{showInvitePersonForm ? inviteTitle : title}</h6>
          {(!!data.length && !showInvitePersonForm) && <OnboardingSearchBar onChange={this.onSearch}/>}
        </div>

        {!showInvitePersonForm &&
          (data.length ?
              filteredData.length ?
                <div>
                  <div className="card invite-list"
                       style={{boxShadow: (data.length > 3 ? '0px -10px 10px -10px #000 inset' : 'none')}}
                  >
                    {filteredData.map(item => (
                      <OnboardingListItem
                        key={item._id}
                        id={item._id}
                        content={item.inviteeEmail}
                        onAction={onResendInvite}
                        actionTitle="resend"
                      />))}
                  </div>
                  <button className="btn btn-block btn-primary" onClick={() => this.setShowInvitePersonForm()}>
                    {inviteTitle}
                  </button>
                </div>
                :
                <div className="card invite-list text-center" style={{paddingTop: 10, paddingBottom: 10}}>
                  No Results
                </div>
              :
              <div style={{margin: '20px 0', textAlign: 'center'}}>
                <button className="btn btn-primary" onClick={() => this.setShowInvitePersonForm()}>
                  {inviteTitle}
                </button>
              </div>
          )
        }
        {showInvitePersonForm &&
          <div>
            <NewInvitationForm onSubmit={this.onInvitePerson} onClose={this.setShowInvitePersonForm}/>
            <h6 className="text-danger">{error}</h6>
          </div>
        }
      </div>
    )
  }
}

export default InvitedPersonsWrapper



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/InvitedPersonsWrapper.js